import React from 'react';
import { Row, Col, Well } from 'react-bootstrap';
import Slider from '@mygooder/react-slick';
import PoiCard from './../shared/PoiCard';
import { NextArrow, PrevArrow } from './../../shared/SliderArrows';

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import times from 'lodash/times';
import find from 'lodash/find';

import './venuescardsslider.scss';

class VenuesCardsSlider extends React.Component {

  constructor(props) {
    super(props);
    this.handleAfterChange = this.handleAfterChange.bind(this);
    this.goToFirstCard = this.goToFirstCard.bind(this);
  }

  handleAfterChange(currentIndex) {

    const sliderCount = this.slider.props.children.length;
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;

    if(sliderCount < currentSlidesToShow) return;

    const minShowIndex = Math.floor(currentSlidesToShow/2);
    let maxShowIndex = (sliderCount - 1) - minShowIndex;
    if(currentSlidesToShow % 2 == 0) maxShowIndex++;

    if(currentIndex < minShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(minShowIndex); 
      }, 0);
      return;
    }

    if(currentIndex > maxShowIndex) {
      let self = this;
      setTimeout(function(){ 
        self.slider.slickGoTo(maxShowIndex); 
      }, 0);
      return;
    }
  }

  goToFirstCard() {
    const currentBreakpoint = this.slider.state.breakpoint;
    const currentSlidesToShow = (find(this.slider.props.responsive, ['breakpoint', currentBreakpoint]) || {}).settings.slidesToShow;
    const minShowIndex = Math.floor(currentSlidesToShow/2);
    /* This defer prevents Key missing error when using inner slider into component lifecycle... :-| */
    let self = this;
    setTimeout(function(){ 
      self.slider.slickGoTo(minShowIndex); 
    }, 0);
  }

  componentDidMount() {
    this.goToFirstCard();
  }

  componentWillUpdate(nextProps) {
    if(this.props.venues != nextProps.venues) {
      this.goToFirstCard();
    }
  }

  render() {

    const slickSettings = {
      afterChange: this.handleAfterChange,
      swipeToSlide: false,
      infinite: false,
      centerMode: true,
      variableWidth: false,
      prevArrow: <PrevArrow/>,
      nextArrow: <NextArrow/>,
      responsive: [ 
        { breakpoint: 768, settings: { initialSlide: 0, slidesToShow: 1, slidesToScroll: 1, arrows: false } }, 
        { breakpoint: 1024, settings: { initialSlide: 0, slidesToShow: 2, slidesToScroll: 1, arrows: true } }, 
        { breakpoint: 9999, settings: { initialSlide: 0, slidesToShow: 3, slidesToScroll: 1, arrows: true } } 
      ]
    };

    const placeholderCards = [<div key={0}><PoiCard/></div>, <div key={1}><PoiCard/></div>, <div key={2}><PoiCard/></div>, <div key={3}><PoiCard/></div>];

    const venueCards = this.props.venues.apiData.map((venue, index) => {

      let ratingStars = [];
      const integerRating = parseInt(venue.rating);
      
      if(integerRating!= NaN) {
        ratingStars = times(integerRating, (index) => { return (<i className="fa fa-star" key={index}>&nbsp;</i>); });
      }

      const htmlText = (
        <div>
          {ratingStars.length > 0 ? <p>{this.props.translate('restaurants.venues_cards_slider.rating')}&nbsp;{ratingStars}</p> : null}
          <p>{venue.address}</p>
        </div>
      );

      return (<div key={index}>
                <PoiCard title={venue.name} 
                        htmlText={htmlText} 
                        buttonText={this.props.translate('restaurants.venues_cards_slider.view_on_maps')} 
                        buttonLink={`https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${venue.place_id}`} 
                        backgroundImage={venue.picture}/>
              </div>)
    });

    return (
      <Row className="restaurants-venuescardsslider-component">
        <Col xs={12}>

          <h3 className="restaurants-venuescardsslider-component__title"><strong>{this.props.translate('restaurants.venues_cards_slider.title')}</strong></h3>

          <Well bsSize="large">
            <Slider ref={c => this.slider = c } {...slickSettings} className="restaurants-venuescardsslider-component__slider">
              {
                this.props.venues.apiData.length > 0 ? venueCards : placeholderCards
              }
            </Slider>
            <p className="text-right"><small>powered by Google</small></p>
          </Well>
        </Col>
      </Row>
    );
  }
}

VenuesCardsSlider.displayName = 'PagesRestaurantsVenuesCardsSlider';
VenuesCardsSlider.propTypes = {};
VenuesCardsSlider.defaultProps = {};

const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    venues: state.venues
  };
};

export default connect(mapStateToProps)(VenuesCardsSlider);



// WEBPACK FOOTER //
// ./components/pages/restaurants/VenuesCardsSlider.js